import request from '@/utils/request'

//获取省份
export function getProvince() {
  return request({
    url: '/region/provinces',
    method: 'get'
  })
}
export function checkStatus(code) {
  return request({
    url:'/auth/heartbeat',
    method: 'post',
    data:code
  })
}

//获取城市
export function getCity(code) {
  return request({
    url:'/region/cities/'+parseInt(code),
    method: 'get'
  })
}


//获取区县
export  function getArea(code) {
  return request({
    url:'/region/counties/'+parseInt(code),
    method:'get'
  })
}


//获取学校
export  function getSchool(code) {
  return request({
    url:'/region/schools/'+parseInt(code),
    method:'get'
  })
}


//账号登录
export  function accountLogin(data) {
  return request({
    url:'/auth/login',
    method:'post',
    data
  })
}


//账号登录
export  function emailLogin(data) {
  return request({
    url:'/auth/login/email',
    method:'post',
    data
  })
}

export  function changePwdCode(data) {
  return request({
    url:'/auth/change-password/auth-email',
    method:'post',
    data
  })
}

export  function signUpCode(data) {
  return request({
    url:'/auth/register/auth-email',
    method:'post',
    data
  })
}


export  function getLogList(page,limit,type) {
  return request({
    url:'/schools/user-logs?role='+type+'&page='+page+'&limit='+limit,
    method:'get'
  })
}
